export const describeResProduct = 'reservedInstanceConst/describeResProduct';

